import React from 'react'
import {Chip} from '@material-ui/core'
import { makeStyles } from '@material-ui/core/styles';
import classNames from 'classnames'
import { STATIC_PATH } from 'src/common/razzle-platform-components/configs'
import urlJoin from 'url-join'



const useStyles = makeStyles(theme => {
    return {
        mapMarker: {
            backgroundColor: theme.palette.primary.contrastText,
            color: theme.palette.primary.main,
            height: '28px',
            width: '38px',
            padding: '0 2px',
            '&:hover': {
                backgroundColor: theme.palette.primary.main,
                color: theme.palette.primary.contrastText,
            },
            '&:focus': {
                backgroundColor: theme.palette.primary.main,
                color: theme.palette.primary.contrastText,
            },
            '& .MuiChip-label': {
                padding: '0 8px',
            },
            '& .MuiChip-icon': {
                marginRight: '-9px',

            },
        },
        mapMarkerHovered: {
            backgroundColor: theme.palette.primary.main,
            color: theme.palette.primary.contrastText,
        },
    }
})



export default function DefaultMarker(props) {
    const classes = useStyles()
    const {handleClick, isHovered, item} = props
    const logoUrl = urlJoin(STATIC_PATH, isHovered ? 'assets/images/CC_BLANC.png' : 'assets/images/CC_BLEU.png')
    return (
        <Chip
            className={classNames(
                "text-center font-semibold text-lg hover:text-xl focus:text-xl hover:z-10 hover:relative",
                isHovered ? `text-xl z-10 relative ${classes.mapMarkerHovered}` : '',
                classes.mapMarker,
            )}
            style={{ boxShadow: 'rgba(0, 0, 0, 0.16) 0px 0px 0px 1px, rgba(0, 0, 0, 0.12) 0px 4px 16px', transform: 'translateX(-50%)' }}
            // label={item.price}
            icon={<img src={logoUrl} />}
            onClick={handleClick}
        />
    )
}
